import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountService, AuthService, CustomerService, ExcelDateConvertService, InvoicesService, PayoutService, UserService } from '../_services';
import { AppConfig, ExcelService, ParameterData } from '../_helpers/index';
import { DatePipe } from '@angular/common';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as moment from 'moment';
import { CurrencyPipe } from '@angular/common';
import { Configuration, PayoutConfirm, PayoutDetails, PayoutInvoiceList, User } from '../_models';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as fs from 'file-saver';
import { PayoutConfigurationExportTemplate } from '../_models';
import { AccountTypeOptions } from '../sharedcomp/constans/routes.constans';
import { BatchProcessUrls } from '../_enums/urls';
import { catchError, finalize, map, takeUntil, tap, timeout } from 'rxjs/operators';
import { Observable, Subject, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';


@Component({
    selector: 'payoutprocessview',
    templateUrl: './payoutprocessview.component.html',
    styleUrls: ['./payoutprocessview.component.css', '../../assets/css/customer-list-table.css']
})

export class PayoutProcessViewComponent implements OnInit, OnDestroy {
    public user_public_id: string;
    customer_public_id: string;
    offsetTimeZone: any;
    offsetMinutes: any;
    offsetTimeVal: any;
    payout_process_id: string;
    created: any;
    reference: any;
    gross_amount: any;
    gross_amount_symbol: any;
    net_amount: any;
    net_amount_symbol: any;
    confirm_payout: any;
    status: any;
    companyAccount: string
    payoutProcessDetails: PayoutDetails;
    avaliable_value: any;
    avaliable_symbol: any;
    isInstaPyoAvaliable: any;
    PayoutDetailAvalibleBalance: any;
    modalInstaPayout= false;
    dataPercentage:any;
    percentageValues: any;
    dataRoleAdminTreasury: any;
    isRoleAdminTreasury: any;
    isUserAdminTreasury: boolean;
    name: any;
    dataSource: MatTableDataSource<PayoutInvoiceList> = new MatTableDataSource([]);;
    displayedColumns: string[] = ['metadata.created', 'resource_related.type', 'metadata.external_id', 'metadata.customer.name', 'total.value', 'to_account.bank.name', 'to_account.account_number', 'status', 'external_id', 'actions'];
    pageSize: number;
    pageIndex: number = 0;
    invoiceStatus: string = '';
    pageStart: number = 0;
    totalResultSize: number;
    PageSizeOptions: number[];
    excelExportData: PayoutInvoiceList[];
    userDetails: any;
    userRole: any;
    userRoleStatus: any;
    isUpdateAvailable = false;
    isDeleteAvailable = false;
    isReadAvailable = false;
    isExportAvailable = false;
    isRejectAvailable = false;
    isExportPSAvailable = false;
    isImportPSPAvailable = false;
    isConfirmAvailable = false;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    exportPSP = new FormControl('BCP');
    invoiceRejectForm: FormGroup;
    rejectInvoiceId: any;
    isCancelAvailable = false;
    isApproveAvailable = false;
    accountList: any;
    @ViewChild("payoutLowBalanceModel") modalContent;
    isAccountReadAvailable = false;
    fileList =[];
    configuration: Configuration = [];
    kbatchTemplate: string;
    confirmForm: FormGroup;
    uploadedFileName = "Archivo a subir";
    enableImportTxt: boolean = true;
    formData: FormData = new FormData();
    uploadFile: File;
    isConfirmButtonActive = false;
    isCancelPreApprovedAvailable = false;
    isCancelButtonActive = false;
    export_templates_list: PayoutConfigurationExportTemplate[];

    baseURL: string = "";
    timeCompleted: boolean = false;
    private destroy$ = new Subject<void>();

    constructor(
        private router: Router,
        private readonly activatedRoute: ActivatedRoute,
        private spinnerService: Ng4LoadingSpinnerService,
        private datePipe: DatePipe,
        private payoutService: PayoutService,
        private excelService: ExcelService,
        private currencyPipe: CurrencyPipe,
        private auth: AuthService,
        private parameterData: ParameterData,
        private invoicesService: InvoicesService,
        private userService: UserService,
        private _fb: FormBuilder,
        private customerService: CustomerService,
        private modalService: NgbModal, private excelDateConvertService:ExcelDateConvertService) {
        this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
        this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
        this.baseURL = AppConfig.settings.apiServer.baseURL + BatchProcessUrls.URL_BATCHES_V1;
        this.InitialSetup();
    }


    ngOnInit(): void {
        this.spinnerService.show();
        var browserStorage;
        let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
        if (browserStorage1 == null) {
            browserStorage = localStorage.getItem('companyId');
            if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
                this.router.navigate(['/home']);
            }
            else {
                this.customer_public_id = localStorage.getItem('companyId');
                this.user_public_id = localStorage.getItem('userId');
            }
        }
        else {
            this.customer_public_id = localStorage.getItem('subcompanyId');
            this.user_public_id = localStorage.getItem('userId');
        }

        browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
        this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');

        if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {
            this.offsetTimeZone = -5.00;
            this.offsetMinutes = 0;
            this.offsetTimeVal = (this.offsetTimeZone * 3600000);
            AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
        }
        else {
            this.offsetTimeZone = browserStorage.getItem('timezone');
            this.offsetMinutes = 30;
            this.offsetTimeVal = (this.offsetTimeZone * 3600000);
            AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
        }
        let params: any = this.activatedRoute.snapshot.params;
        this.payout_process_id = params.id;
        this.paginator._intl.itemsPerPageLabel = "Registros por página";
        this.paginator._intl.nextPageLabel = "siguiente página";
        this.paginator._intl.lastPageLabel = "última página";
        this.paginator._intl.previousPageLabel = "anterior página";
        this.paginator._intl.firstPageLabel = "primera página";
        this.checkThisPageGrants();
        this.getInvoiceListFromPayout();
        this.getConfiguration();
        this.getCustomerAccountList();
        this.getPayoutConfiguration();
        this.porcentageInstaPyoApi();
        // this.getRole();
    }

    ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
    }

    onFileChange(event: any) {
        const target: DataTransfer = <DataTransfer>(event.target);
        if (target.files.length > 1) throw new Error('Cannot use multiple files');
        if (target.files.length === 1) {
            this.enableImportTxt = false;
            this.uploadedFileName = event.target.files[0].name;
            this.uploadFile = event.target.files[0];
            this.confirmForm.get('file_to_upload').setValue(this.uploadFile);
        }
    }

    InitialSetup() {
        this.invoiceRejectForm = this._fb.group({
            description: new FormControl('',[Validators.required]),
          })
        this.confirmForm = this._fb.group({
            bank_name: new FormControl('BCP',[Validators.required]),
            bank_operation: new FormControl('',[Validators.required]),
            paid_amount : new FormControl('',[Validators.required]),
            company_payout_process_reference : new FormControl('',[Validators.required]),
            file_to_upload : new FormControl('',[Validators.required])
        })
        this.uploadedFileName = "Archivo a subir";
    }

    getProperty = (obj, path) => (
        path.split('.').reduce((o, p) => o && o[p], obj)
    )

    ngAfterViewInit() {
        this.dataSource.sortingDataAccessor = (obj, property) => this.getProperty(obj, property);
        this.dataSource.sort = this.sort;
    }

    // getRole(){
    //     this.customerService.getCustomerUserList(this.customer_public_id).subscribe(data => {
    //         this.dataRoleAdminTreasury = data;
    //       }, error => {
    //           console.error('Failed' + error);
    //       })
    // }

    porcentageInstaPyoApi() {
        this.payoutService.porcentageInstaPyo(this.customer_public_id).subscribe(data => {
            this.dataPercentage = data;
            this.percentageValues = this.dataPercentage.values.dispersion_percentage;
          }, error => {
              console.error('Failed' + error);
          })
      }

    getPayoutDetailAvalibleBalanceApi(currency: string, data : PayoutDetails): void {
        this.payoutService.getPayoutDetailAvalibleBalance(currency).subscribe(data => {
            this.PayoutDetailAvalibleBalance = data;
            this.avaliable_value = data.available_balance.value;
            this.avaliable_symbol = data.available_balance.symbol;
            const porcentageMountingToDisperse = (this.percentageValues * (this.gross_amount - this.payoutProcessDetails.metadata.totals.rejected_total.value) + (this.gross_amount - this.payoutProcessDetails.metadata.totals.rejected_total.value));
            if (this.avaliable_value >= porcentageMountingToDisperse) {
                this.isInstaPyoAvaliable = true;
            } else {
                this.isInstaPyoAvaliable = false;
            }
           }
        );
    }

    confirmInstaPayout() { 
        const porcentageMountingToDisperse = (this.percentageValues * (this.gross_amount - this.payoutProcessDetails.metadata.totals.rejected_total.value) + (this.gross_amount - this.payoutProcessDetails.metadata.totals.rejected_total.value));
        if (this.avaliable_value >= porcentageMountingToDisperse) {
            this.modalInstaPayout = true;
            setTimeout(() => {
                this.modalInstaPayout = false;
            }, 3000);
            
            this.payoutService.confirmInstaPayout(this.payout_process_id).pipe(
            ).subscribe(
                data => {

                },
                error => {
                    console.error(error);
                }
            );
        } 
    }
    
    getPayoutProcessDetails() {
        this.payoutService.getPayoutProcessDetails(this.payout_process_id).subscribe(data => {
                this.payoutProcessDetails = data;
                this.name = this.payoutProcessDetails.name;
                this.created = this.payoutProcessDetails.created;
                this.reference = this.payoutProcessDetails.reference;
                this.gross_amount = this.payoutProcessDetails.gross_amount.value;
                this.gross_amount_symbol = this.payoutProcessDetails.gross_amount.symbol;
                this.net_amount = this.payoutProcessDetails.net_amount.value;
                this.net_amount_symbol = this.payoutProcessDetails.net_amount.symbol;
                this.status = this.payoutProcessDetails.status;
                this.companyAccount = this.payoutProcessDetails.company_account.public_id;
                if (data && data.company_account && data.company_account.balance) {
                    this.getPayoutDetailAvalibleBalanceApi(data.company_account.balance.currency,data);
                }

            let activity_list = this.payoutProcessDetails.activity_list.filter(item => item.status == 'COMPLETED');
            let activity_list_confirm = this.payoutProcessDetails.activity_list.filter(item => item.status == 'CONFIRMED');
            if (activity_list_confirm.length > 0) {
                this.isConfirmButtonActive = true;
            }
            if (activity_list.length > 0) {
                this.confirm_payout = activity_list[0].created;
            }

            let activity_list_cancel = [];
            if (this.isCancelAvailable) {
                activity_list_cancel = this.payoutProcessDetails.activity_list.filter(item => item.status == 'CONFIRMED' || item.status == 'CREATED');
            }
            if (this.isCancelPreApprovedAvailable) {
                activity_list_cancel = this.payoutProcessDetails.activity_list.filter(item => item.status == 'CREATED');
            }
            activity_list_cancel.length > 0 ? this.isCancelButtonActive = true : this.isCancelButtonActive = false;

            this.displayFileList();
            this.spinnerService.hide();
        }, error => {
            console.error('Failed! while trying to get the getPayoutProcessDetails. ' + error);
        });
    }

    displayFileList() {
        if (this.payoutProcessDetails.metadata.file_list != undefined && Object.keys(this.payoutProcessDetails.metadata.file_list).length > 0) {
            this.fileList = this.payoutProcessDetails.metadata.file_list;
        }
    }

    getConfiguration() {
        this.payoutService.getPayoutServiceConfiguration(this.customer_public_id).subscribe(data => {
          this.export_templates_list = data.values.detail.export_templates;
        }, error => {
            this.spinnerService.hide();
            console.error('Failed while trying to get export templates.' + error);
        })
      }

    exportTemplate(template: string) {
        this.spinnerService.show();
        this.payoutService.downloadFilePayout(this.customer_public_id, this.payout_process_id, template).subscribe(data => {
            const storageUrl = data.body.storage_url;
            if (storageUrl !== undefined) {
                location.href = storageUrl;
            } else {
                console.error('Failed while trying to export invoice list from payout detail.' + data);
            }
            this.spinnerService.hide();
        }, error => {
            this.spinnerService.hide();
            console.error('Failed while trying to export invoice list from payout detail.' + error);
        })
      }

    exportAsXLSX(export_templates) {
        this.spinnerService.show();
        if (this.configuration.status == 'ACTIVE') {
            this.payoutService.downloadFile(this.payout_process_id, export_templates)
            .pipe(
                timeout(10000)
            )
            .subscribe(data => {
                location.href = data.body.storage_url;
                this.spinnerService.hide();
            },
                error => {
                    if (error.name === 'TimeoutError') {
                        this.timeCompleted = true;
                    }
                    this.spinnerService.hide();
                    console.error('Failed! while trying to download the file. ' + error.error)

                })
        } else {
            this.setExportExcelFileData(this.excelExportData, this.name);
        }
    }

    downloadPSPFile() {
        this.spinnerService.show();
        this.payoutService.downloadPSPFile(this.payout_process_id, this.exportPSP.value).subscribe(data => {
            this.download(data.body.storage_url);
        },
            error => {
                console.error('Failed! while trying to downloadPSPFile. ' + error)

            })
    }

    download(url){
        this.spinnerService.show();
        const fileName = this.name+".txt";
        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.send(null);
        request.onreadystatechange = function () {
            if (request.readyState === 4 && request.status === 200) {
                var type = request.getResponseHeader('Content-Type');
                if (type.indexOf("text") !== 1) {
                    const blob = new Blob([request.responseText], { type: 'text/txt' });
                    fs.saveAs(blob, fileName);
                }
            }
        }
        this.spinnerService.hide();
    }
    downloadFile(url) {
        var filename = url.split('/').pop();
        try {
            fs.saveAs(url, filename);
        }
        catch (e) {
            console.error(e)
        }
    }

    setExportExcelFileData(excelExportData, tempName) {
        var excelHeader = ["Fecha", "Tipo de operación","Nombre de plantilla","Referencia", "Tipo documento","Número documento","Id Jugador","Cliente", "Moneda","Total", "Banco", "Cuenta", "Estado", "Operación", "Observación"];
        var arrFinalData = [];
        var object_temp = {};
        var i = 0;
        var columnsKeyNames = [];
        for (i = 0; i < excelExportData.length; i++) {
            var singleRec_temp = excelExportData[i];
            columnsKeyNames = Object.keys(singleRec_temp);
            var created_temp, type_temp, external_id_temp, name_temp, total_temp, bank_name_temp,
                account_number_temp, status_temp, reference_temp = "", desc_temp = "", symbol_temp,
                payout_name_temp = "", document_type_temp = "", document_id_temp = "", customer_external_id_temp = "";
            object_temp = {};
            for (var j = 0; j < columnsKeyNames.length; j++) {
                if (columnsKeyNames[j] == "metadata") {
                    created_temp = singleRec_temp[columnsKeyNames[j]].created;
                }
                if (columnsKeyNames[j] == "resource_related") {
                    var temp_type = singleRec_temp[columnsKeyNames[j]].type;
                    switch (temp_type) {
                        case "invoice":
                            type_temp = "Orden de Pago"
                            break;
                        case "Fee":
                            type_temp = "Comisión"
                        default:
                            type_temp = temp_type

                    }
                }
                if (columnsKeyNames[j] == "metadata") {
                    payout_name_temp = tempName;
                    document_type_temp = singleRec_temp[columnsKeyNames[j]].customer.document_type;
                    document_id_temp = singleRec_temp[columnsKeyNames[j]].customer.document_number;
                    customer_external_id_temp = singleRec_temp[columnsKeyNames[j]].customer.external_id;
                }

                if (columnsKeyNames[j] == "metadata") {
                    external_id_temp = singleRec_temp[columnsKeyNames[j]].external_id;
                }
                if (columnsKeyNames[j] == "metadata") {
                    name_temp = singleRec_temp[columnsKeyNames[j]].customer.name;
                }
                if (columnsKeyNames[j] == "total") {
                    total_temp = this.currencyPipe.transform(singleRec_temp[columnsKeyNames[j]].value, "", "");
                    symbol_temp = singleRec_temp[columnsKeyNames[j]].currency;
                }
                if (columnsKeyNames[j] == "to_account") {
                    bank_name_temp = singleRec_temp[columnsKeyNames[j]].bank.name;
                }
                if (columnsKeyNames[j] == "to_account") {
                    account_number_temp = singleRec_temp[columnsKeyNames[j]].account_number;
                }
                if (columnsKeyNames[j] == "metadata") {
                    desc_temp = singleRec_temp[columnsKeyNames[j]].rejected_reason;
                    var temp_status = singleRec_temp[columnsKeyNames[j]].status;
                    switch (temp_status) {
                        case "NEW":
                            status_temp = 'Pendiente'
                            break;
                        case "PENDING":
                            status_temp = 'Pendiente'
                            break;
                        case "PROCESSING":
                            status_temp = 'Procesando'
                            break;
                        case "PAID":
                            status_temp = 'Pagado'
                            break;
                        case "VOIDED":
                            status_temp = 'Anulado'
                            break;
                        case "EXPIRED":
                            status_temp = 'Expirado'
                            break;
                        case "VOIDED_CUSTOMER":
                            status_temp = 'Anulado'
                            break;
                        case "OVERDUE":
                            status_temp = 'Vencido'
                            break;
                        case "PAYMENT_ON_HOLD":
                            status_temp = 'Pendiente'
                            break;
                        case "REJECTED":
                            status_temp = 'Rechazado'
                            break;
                        default:
                            status_temp = temp_status
                    }
                }
                if (columnsKeyNames[j] == "external_id") {
                    reference_temp = singleRec_temp[columnsKeyNames[j]];
                }
            }
            for (var k = 0; k < excelHeader.length; k++) {
                if (excelHeader[k] == "Fecha") {
                    object_temp[excelHeader[k]] = this.excelDateConvertService.convertExcelDateTime(created_temp);
                }
                if (excelHeader[k] == "Tipo de operación") {
                    object_temp[excelHeader[k]] = type_temp;
                }
                if (excelHeader[k] == "Nombre de plantilla") {
                    object_temp[excelHeader[k]] = payout_name_temp;
                }
                if (excelHeader[k] == "Referencia") {
                    object_temp[excelHeader[k]] = external_id_temp;
                }
                if (excelHeader[k] == "Tipo documento") {
                    object_temp[excelHeader[k]] = document_type_temp;
                }
                if (excelHeader[k] == "Número documento") {
                    object_temp[excelHeader[k]] = document_id_temp;
                }
                if (excelHeader[k] == "Id Jugador") {
                    object_temp[excelHeader[k]] = customer_external_id_temp;
                }
                if (excelHeader[k] == "Cliente") {
                    object_temp[excelHeader[k]] = name_temp;
                }
                if (excelHeader[k] == "Moneda") {
                    object_temp[excelHeader[k]] = symbol_temp;
                }
                if (excelHeader[k] == "Total") {
                    object_temp[excelHeader[k]] = total_temp;
                }
                if (excelHeader[k] == "Banco") {
                    object_temp[excelHeader[k]] = bank_name_temp;
                }
                if (excelHeader[k] == "Cuenta") {
                    object_temp[excelHeader[k]] = account_number_temp;
                }
                if (excelHeader[k] == "Estado") {
                    object_temp[excelHeader[k]] = status_temp;
                }
                if (excelHeader[k] == "Operación") {
                    object_temp[excelHeader[k]] = reference_temp;
                }
                if (excelHeader[k] == "Observación") {
                    object_temp[excelHeader[k]] = desc_temp;
                }
            }
            arrFinalData.push(object_temp);
        }
        this.spinnerService.hide();
        this.excelService.exportAsExcelFileForPayoutProcessView(arrFinalData, 'Payout Process '+ this.reference);
    }

    viewInvoiceDetails(element) {
        this.spinnerService.show();
        const application = localStorage.getItem('application');
        if (AccountTypeOptions[application] != undefined) {
          this.router.navigate([`/${AccountTypeOptions[application]}/invoices/${element}/view`]);
        }
    }

    viewCustomerDetails(element) {
        this.spinnerService.show();
        this.router.navigate([`/customers/${element.metadata.customer.public_id}/view`]);
    }

    payoutgridActionClick(type, publicid) {
        switch (type) {
            case 'READ':
                this.viewInvoiceDetails(publicid);
                break;
            case 'REJECT':
                this.InitialSetup();
                this.rejectInvoiceId = publicid;
                break;
        }
    }

    rejectInvoice() {
        this.spinnerService.show();
        let rejectDescription = this.invoiceRejectForm.controls['description'].value;
        this.payoutService.rejectInvoice(this.rejectInvoiceId, rejectDescription).subscribe(result => {
            this.getPayoutProcessDetails();
        },
            error => {
                console.error('Failed while trying to reject the invoice Details.' + error);
            })
    }
    onConfirmInvoice(publicid) {
        this.invoicesService.deleteInvoice(publicid)
            .subscribe((result) => {
                this.getPayoutProcessDetails();
            }, error => {
                console.error('Failed while trying to cancel the invoice Details.' + error);
            });
    }

    duplicateInvoiceDetails(publicid) {
        this.parameterData.InvoiceIdParameters = publicid;
        this.router.navigate(['/invoices/create']);
    }

    async getUserRoleStatus() {
        try {
            const data = await this.userService.getUserDetails(localStorage.getItem('userId'));
            this.userDetails = data;
            this.isRoleAdminTreasury = data.role
            this.userRole = this.userDetails.role;
            this.userRoleStatus = this.userDetails.status;
        }
        catch (error) {
            console.error('Failed while trying to getUserRoleStatus.' + error)
        }

    }

    getCustomerAccountList() {
        this.customerService.getCustomerAccountList(this.customer_public_id, '').subscribe(data => {
            this.accountList = data;
        },
            error => {
                console.error('Failed! while trying to get the accounts list. ' + error);
            });
    }

  approve() {
    this.spinnerService.show();
    if (this.accountList !== undefined && this.accountList !== null) {
      let payableAccountList = this.getPayableAccountList(this.companyAccount, this.accountList);
      let executePayoutProcess = {
        "confirm_payout": { "to_account": { "public_id": payableAccountList } }
      }
      this.payoutService.executePayoutProcess(this.payout_process_id, executePayoutProcess).subscribe(result => {
        this.getPayoutProcessDetails();
      },
        err => {
          if (err.status == 400 && err.error == "No balance in Payout Account") {
            this.openLowBalanceModel();
          }
          this.spinnerService.hide();
          if (err.status != 400) {
            console.error('Failed while trying to approve the payout.' + err.error);
          }
        })
    } else {
      console.error('Account list undefined or null. Check account list service.')
    }
  }

  getPayableAccountList(publicId: string, accountList) {
    const account = accountList.find(t => t.public_id === publicId);
    if (!account) {
      console.error('No account find from account list.')
      return '';
    }

    const currency = account.balance.currency;
    if (!currency) {
      return '';
    }

    const payableAccount = accountList.find(t => t.type === 'PAYABLE' && t.balance.currency === currency);
    if (!payableAccount) {
      return '';
    }

    return payableAccount.public_id;
  }

    openLowBalanceModel() {
        this.modalService.open(this.modalContent, { ariaLabelledBy: 'payoutLowBalanceModelTitle' })
      }

    cancel() {
        this.spinnerService.show();
        this.payoutService.cancelPayoutProcess(this.payout_process_id).subscribe(result => {
            this.getPayoutProcessDetails();
        },
            error => {
                this.spinnerService.hide();
                console.error('Failed while trying to cancel the PayoutProcess.' + error);
            })
    }

    goToAccount(){
        let payoutAccountList = this.accountList.filter(t => t.type == 'PAYOUT');
        if(payoutAccountList.length > 0){
          this.router.navigate([`/accounts/payout/${payoutAccountList[0].public_id}/operations`]);
        }
      }

    filterStatusDetails(status: string) {
      if (this.invoiceStatus !== status) {
        this.spinnerService.show();
        this.invoiceStatus = status;
        this.pageStart = 0;
        this.pageIndex = 0;
        this.paginator.pageIndex = 0;
        this.getInvoiceListFromPayout();
      }
    }

    getPayoutConfiguration(){
        this.payoutService.getPayoutConfiguration(this.customer_public_id).subscribe(data => {
            this.configuration = data;
            if(this.configuration.values.export_psp_list != null && this.configuration.values.export_psp_list != undefined){
                if(this.configuration.values.export_psp_list.length > 0){
                    this.exportPSP.setValue(this.configuration.values.export_psp_list[0].value);
                }
            }
          }, error => {
            console.error('Failed! while trying to get the payout export template details. ' + error.error);
          })
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            if (!((charCode >= 37 && charCode <= 42) || charCode == 45 || charCode == 46 || charCode == 35 || charCode == 32)) {
                return false;
            }
        }
        return true;
    }

    confirm({ value }: { value: PayoutConfirm }) {
        this.spinnerService.show();
        const json_data = {
            "bank_name": `${value.bank_name}`,
            "bank_operation": `${value.bank_operation}`,
            "paid_amount": `${value.paid_amount}`,
            "user": `${this.user_public_id}`
        };
        this.formData.append('file_to_upload', new Blob([this.confirmForm.get('file_to_upload').value], { type: this.uploadFile.type }), this.uploadFile.name);
        this.formData.append('bank_name', value.bank_name);
        this.formData.append('bank_operation', value.bank_operation);
        this.formData.append('is_ops', 'True');
        this.formData.append('metadata', JSON.stringify(json_data))
        this.payoutService.confirmOperations(this.payout_process_id, this.formData).subscribe(data => {
            this.getPayoutProcessDetails();
        }, error => {
            console.error('Failed! while trying to confirm the operations ' + error.error);
        })
    }

    async checkThisPageGrants() {
        await this.getUserRoleStatus();
        await this.auth.isKashioGrantsAvailable();
        this.isReadAvailable = this.auth.checkGrants('INVOICES', 'READ');
        this.isUpdateAvailable = this.auth.checkGrants('INVOICES', 'UPDATE');
        this.isDeleteAvailable = this.auth.checkGrants('INVOICES', 'DELETE');
        this.isApproveAvailable = this.auth.checkGrants('PAYOUTS', 'APPROVE');
        this.isCancelAvailable = this.auth.checkGrants('PAYOUTS', 'CANCEL');
        this.isAccountReadAvailable = this.auth.checkGrants('ACCOUNTS', 'READ');
        this.isExportAvailable = this.auth.checkGrants('PAYOUTS', 'EXPORT');
        this.isExportPSAvailable = this.auth.checkGrants('PAYOUTS', 'EXPORT-FILE-PSP');
        this.isImportPSPAvailable = this.auth.checkGrants('PAYOUTS', 'IMPORT-FILE-PSP');
            this.isRejectAvailable = this.auth.checkGrants('INVOICES', 'REJECT');
            this.isConfirmAvailable = this.auth.checkGrants('PAYOUTS', 'CONFIRM');
        this.isCancelPreApprovedAvailable = this.auth.checkGrants('PAYOUTS', 'CANCEL-PREAPPROVED');
        this.getPayoutProcessDetails();
    }

    getInvoiceListFromPayout() {
      this.payoutService.getInvoiceListFromPayout(this.payout_process_id, this.pageSize, this.pageStart, this.invoiceStatus)
      .pipe(
        takeUntil(this.destroy$),
        tap(invoices => {
          const resources = invoices.data;
          this.excelExportData = resources;
          this.dataSource.data = resources;
          this.totalResultSize = invoices.records;
          this.spinnerService.hide();
        }),
        catchError(error => {
          console.error('Failed! while trying to get the get invoice list. ' + error)
          this.spinnerService.hide();
          return of(null);
        })
      )
      .subscribe();
    }

    gridPageChange(event) {
        this.spinnerService.show();
        this.pageSize = event.pageSize;
        this.pageStart = event.pageIndex * event.pageSize;
        this.pageIndex = event.pageIndex;
        this.getInvoiceListFromPayout();
    }

    closeModal() {
        this.timeCompleted = false;
    };
}
